import { Timestamp } from 'google-protobuf/google/protobuf/timestamp_pb';
import * as google_protobuf_timestamp_pb from 'google-protobuf/google/protobuf/timestamp_pb';
import { Inventory } from 'src/app/proto/generated/inv_common_message_pb';
import { InventoryBase } from './inventory-base.model';
import { InventoryTaskModel } from './inventory-task.model';
import { InventoryVersion } from './inventory-version.model';

enum ExpectedGroupCategory {
  Asset = 'Asset',
  Inventory = 'Inventory',
  ServicePoint = 'ServicePoint',
  Contact = 'Contact',
}

export class InventoryModel extends InventoryBase {
  ContractId: string;
  ContractTitle: string;
  JsonData: any;
  Active: boolean;
  Position: Uint8Array | string;
  PositionSrid: number;
  Versions: Array<InventoryVersion>;
  PostProcessing: string;
  GeoFence: Uint8Array | string;
  Tasks: Array<InventoryTaskModel>;
  SerialNumber: string;
  UtilityId: string;
  Type: string;
  EventDate: Date;
  ContractTimeZone: string;
  MexFlag: boolean;
  EventDateWithTime: Date;

  static MapperList(source: Inventory[]): InventoryModel[] {
    const list: InventoryModel[] = [];
    source?.forEach((element) => {
      list.push(InventoryModel.Mapper(element));
    });
    return list;
  }

  static Mapper(source: Inventory): InventoryModel {
    const destination: InventoryModel = new InventoryModel();

    if (source != null) {
      const jsonObj = JSON.parse(source.getJsonData());
      for (const prop in jsonObj) {
        if (typeof jsonObj[prop] === 'object') {
          for (const internalProp in jsonObj[prop]) {
            destination[internalProp] = jsonObj[prop][internalProp];
          }
        } else {
          destination[prop] = jsonObj[prop];
        }
      }

      destination.ContractTitle = source.getContractTitle();
      destination.JsonData = JSON.parse(source.getJsonData());
      destination.Active = source.getActive();
      destination.Audited = source.getAudited();
      destination.AuditorName = source.getAuditorName();
      destination.Position = source.getPosition();
      destination.name = source.getInventoryName();
      destination.ContractId = source.getContractName();
      destination.FsrIdentifier = source.getFsrName();
      destination.AssignedTo = source.getAssignedTo();
      destination.StatusWeb = source.getStatusWeb();
      destination.ServiceType = source.getServiceType();
      destination.Versions = InventoryVersion.MapperList(
        source.getVersionsList()
      );
      destination.GeoFence = source.getGeofence();
      destination.Tasks = InventoryTaskModel.MapperList(source.getTasksList());

      destination.EventDate =
        source.getEventDate() != null
          ? this.toDateOnly(source.getEventDate())
          : null;

      destination.EventDateWithTime =
        source.getEventDate() != null
          ? this.toDateTimeOnly(source.getEventDate()?.toDate())
          : null;

      if (destination.JsonData[ExpectedGroupCategory.Inventory]) {
        destination.JsonData.Inventory.ContractName = source.getContractTitle();
      }

      destination.ContractTimeZone = source.getContractTimeZone();
    }

    return destination;
  }

  static MapperProto(source: InventoryModel): Inventory {
    const destination: Inventory = new Inventory();
    const jsonData = { ...source.JsonData };

    destination.setContractName(source.ContractId);
    destination.setActive(source.Active);
    destination.setAudited(source.Audited);
    destination.setAuditorName(source.AuditorName);
    destination.setPosition(source.Position);
    destination.setInventoryName(source.name);
    destination.setJsonData(JSON.stringify(jsonData));
    destination.setFsrName(source.FsrIdentifier);
    destination.setAssignedTo(source.AssignedTo);
    destination.setServiceType(source.ServiceType);
    destination.setContractTitle(source.ContractTitle);
    destination.setStatusWeb(source.StatusWeb);
    destination.setVersionsList(
      InventoryVersion.MapperProtoList(source.Versions)
    );

    const createdOnDate = new google_protobuf_timestamp_pb.Timestamp();
    createdOnDate.fromDate(new Date(Date.now()));
    destination.setCreatedOn(createdOnDate);

    const eventDate = new google_protobuf_timestamp_pb.Timestamp();
    eventDate.fromDate(new Date(source.EventDate));
    destination.setEventDate(eventDate);

    destination.setGeofence(source.GeoFence);
    destination.setTasksList(InventoryTaskModel.MapperProtoList(source.Tasks));
    return destination;
  }

  private static toDateOnly(timestamp: Timestamp): Date {
    if (timestamp == null) {
      return null;
    }

    const tmpDate = new Date(timestamp.getSeconds() * 1000);
    return tmpDate.getUTCFullYear() <= 1970
      ? null
      : new Date(
          tmpDate.getUTCFullYear(),
          tmpDate.getUTCMonth(),
          tmpDate.getUTCDate(),
          0,
          0,
          0,
          0
        );
  }

  private static toDateTimeOnly(date: Date): Date {
    if (date == null) {
      return null;
    }

    return date.getUTCFullYear() <= 1970 ? null : date;
  }
}
